export default "__VITE_ASSET__f9ddc16c__"